import cx from 'classnames';
import { forwardRef } from 'react';

import { Box, BoxProps } from '../Box';

import * as styles from './List.css';
export interface ListProps extends BoxProps {
  variant?: 'base' | 'ordered' | 'unordered';
}

export const List = forwardRef<HTMLLIElement | HTMLOListElement, ListProps>(function List(
  { variant = 'base', ...props }: ListProps,
  ref
) {
  return (
    <Box
      component={variant === 'ordered' ? 'ol' : 'ul'}
      className={cx({
        [styles[variant]]: true,
        [props.className as string]: !!props.className,
      })}
      {...props}
      ref={ref}
    />
  );
});

export type ListItemProps = BoxProps;

export const ListItem = forwardRef<HTMLLIElement, ListItemProps>(function ListItem(
  props: ListItemProps,
  ref
) {
  return <Box ref={ref} component="li" {...props} />;
});
